"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisplayDictionary = exports.isDisplayDictionaryKey = exports.DisplayDictionaryKeys = void 0;
const Util_1 = require("./Util");
exports.DisplayDictionaryKeys = [
    'button.label',
    'button.icon',
    'free_text.label',
    'free_text.placeholder',
    'free_text.no_suggestions',
    'free_text.aria_label',
    'free_text.aria_label_with_suggestions',
    'free_text.empty_search_error',
    'locale.label',
    'locale.placeholder',
    // TODO remove external_link when we build add-ons
    'external_link.pre_link_text',
    'external_link.link_text',
    'button.aria_label'
];
const isDisplayDictionaryKey = (string) => exports.DisplayDictionaryKeys.includes(string);
exports.isDisplayDictionaryKey = isDisplayDictionaryKey;
const isDisplayDictionary = (dict) => {
    try {
        const castDict = dict;
        return exports.DisplayDictionaryKeys.every((key) => (0, Util_1.isString)(castDict[key]));
    }
    catch (e) {
        return false;
    }
};
exports.isDisplayDictionary = isDisplayDictionary;
//# sourceMappingURL=DisplayDictionary.js.map